import ToggleButton from "../../../Components/common/ToggleButton/ToggleButton";

const Header = ({
  selectedProduct,
  selectedHost,
  toggleProps = { show: false, text: "", active: false, onClick: () => {} },
}) => {
  return (
    <div className="products-body-header">
      <h3 className="products-body-header__title">
        {selectedProduct} / <span>{selectedHost}</span>
      </h3>
      {toggleProps.show ? (
        <div className="services-body-header__auto-update">
          <span>{toggleProps.text}</span>
          <ToggleButton active={toggleProps.active} onClick={toggleProps.onClick} />
        </div>
      ) : null}
      <p className="products-body-header__description">
        <span> NOTE:</span> Detailed notification and transform settings of the mailgateway module
      </p>
    </div>
  );
};

export default Header;
